import React from 'react';
import lottie from 'lottie-web';
import styled from 'styled-components';

import { Mask } from '../../lib/components/LessonPath/static/style';

import { Button } from '../../components/dialog/static/style';

lottie.setQuality('low');

const GiftPicture = (props) => {
    setTimeout(() => {
        const giftElement = document.getElementById("gift_piece");
        if (giftElement) {
            lottie.loadAnimation({
                container: giftElement, //包含动画的DOM元素
                renderer: "svg",
                loop: true,
                autoplay: true,
                path: window.publicUrl + "static/lottie/piece.json" //动画的路径
            });
        }
    }, 100);

    return (
        <GiftMask zIndex='999' onClick={props.onClick}>
            <GiftBox id='gift_piece'>
                <Picture src={props.src} alt='' />
                <LinkButton
                    type='left'
                    onClick={props.clickGiftHandler}
                >
                    查看礼物
                </LinkButton>
            </GiftBox>
        </GiftMask>
    );
}

export default GiftPicture;

const GiftMask = styled(Mask)`
    cursor: pointer;
`;

const GiftBox = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    width: 9rem;
    height: 9rem;
`;

const Picture = styled.img`
    position: absolute;
    top: 0.5rem;
    left: 50%;
    transform: translate(-50%);
    -webkit-transform: translate(-50%);
    width: 8rem;
    z-index: 10;
`;

const LinkButton = styled(Button)`
    top: auto;
    bottom: 0;
    left: 50%;
    transform: translate(-50%);
    -webkit-transform: translate(-50%);
    text-align: center;
    line-height: 0.8rem;
    height: 0.8rem;
    z-index: 111;
`;


// WEBPACK FOOTER //
// ./src/components/lesson-path/gift-picture.js